module.exports = __webpack_public_path__ + "static/img/064.d50d3bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/064.jpg
// module id = dYsp
// module chunks = 0